
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { Box } from "@mui/material";
import { ChartsContext } from "../ChartsContext";
import moment from "moment";

interface Props {
  title: string;
  fromOverview?: boolean;
}


export function ReturnBar({ title, fromOverview = false }: Props): JSX.Element {
  const navigate = useNavigate();
  const { survey } = useContext(ChartsContext);
  // Formato: Month Day, Year (ej: January 17, 2023)
  const creationDate = moment(survey.createdAt).format('MMMM D, YYYY');
  
  // Si es desde overview, siempre navegar a surveys-slack
  // Si es desde questions-data y es un template (templateId > 1, excluyendo pulse que es 1), navegar a overview
  // Si es custom (templateId 0 o null) o pulse (templateId 1), navegar a surveys-slack
  const handleBackClick = () => {
    if (fromOverview) {
      navigate('/surveys-slack');
    } else if (survey.templateId && survey.templateId > 1) {
      navigate(`/charts/${survey.id}/overview`);
    } else {
      navigate('/surveys-slack');
    }
  };
  
  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '12px',
        border: '1.5px solid #e0e0e0',
        boxShadow: 'none',
        padding: '14px 18px',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '60px',
        marginBottom: '10px',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <ArrowBackIcon
          sx={{
            color: '#1A237E',
            fontSize: 24,
            cursor: 'pointer',
            marginRight: '10px',
            verticalAlign: 'middle',
          }}
          onClick={handleBackClick}
        />
        <span
          style={{
            fontSize: '20px',
            fontFamily: 'IBM Plex Sans, sans-serif',
            fontWeight: 600,
            color: '#1A237E',
            lineHeight: 1.1,
            verticalAlign: 'middle',
            display: 'inline-block',
          }}
        >
          {title}
        </span>
      </Box>
      <span
        style={{
          fontSize: '14px',
          fontFamily: 'IBM Plex Sans, sans-serif',
          fontWeight: 400,
          color: '#444',
          marginTop: '2px',
          letterSpacing: '0.01em',
          display: 'block',
          marginLeft: '34px', // igual al espacio de la flecha + gap
        }}
      >
        {creationDate}
      </span>
    </Box>
  );
}
